import React, { useState } from "react";
import Image from "../../../components/AppImage";
import DevProfile from "/assets/images/yashprofile.jpg";

const HeroImage = () => {
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <div className="relative group">
      {/* Main Image Container */}
      <div className="relative w-80 h-80 lg:w-96 lg:h-96 mx-auto">
        {/* Background Glow */}
        <div className="absolute inset-0 bg-gradient-to-br from-conversion-accent/20 to-trust-builder/20 rounded-full blur-3xl opacity-0 group-hover:opacity-100 transition-smooth duration-700" />

        {/* Image Frame */}
        <div className="relative w-full h-full rounded-full overflow-hidden border-4 border-border/30 group-hover:border-conversion-accent/50 transition-smooth">
          {/* Loading Skeleton */}
          {!imageLoaded && (
            <div className="absolute inset-0 bg-gradient-to-br from-muted/50 to-muted/30 animate-pulse" />
          )}

          {/* Professional Image */}
          <Image
            src={DevProfile}
            alt="Professional Developer Portrait"
            className="w-full h-full object-cover transition-smooth group-hover:scale-105"
            onLoad={() => setImageLoaded(true)}
          />

          {/* Overlay Gradient */}
          <div className="absolute inset-0 bg-gradient-to-t from-background/20 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-smooth" />
        </div>

        {/* Floating Tech Icons */}
        <div className="absolute -top-4 -right-4 w-12 h-12 bg-card border border-border rounded-lg flex items-center justify-center opacity-0 group-hover:opacity-100 transition-smooth duration-500 delay-100">
          <span className="text-conversion-accent font-mono text-sm font-bold">
            JS
          </span>
        </div>

        <div className="absolute -bottom-4 -left-4 w-12 h-12 bg-card border border-border rounded-lg flex items-center justify-center opacity-0 group-hover:opacity-100 transition-smooth duration-500 delay-200">
          <span className="text-trust-builder font-mono text-sm font-bold">
            ⚛️
          </span>
        </div>

        <div className="absolute top-1/2 -left-6 w-10 h-10 bg-card border border-border rounded-lg flex items-center justify-center opacity-0 group-hover:opacity-100 transition-smooth duration-500 delay-300">
          <span className="text-cta font-mono text-xs font-bold">TS</span>
        </div>

        {/* Status Indicator */}
        <div className="absolute bottom-4 right-4 flex items-center space-x-2 bg-card/90 backdrop-blur-sm border border-border rounded-full px-3 py-1">
          <div className="w-2 h-2 bg-success rounded-full animate-pulse" />
          <span className="text-xs text-muted-foreground font-medium">
            Available
          </span>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none">
        <div
          className="absolute top-1/4 left-1/4 w-2 h-2 bg-conversion-accent rounded-full opacity-30 animate-pulse"
          style={{ animationDelay: "0s" }}
        />
        <div
          className="absolute top-3/4 right-1/4 w-1 h-1 bg-trust-builder rounded-full opacity-40 animate-pulse"
          style={{ animationDelay: "1s" }}
        />
        <div
          className="absolute bottom-1/4 left-1/3 w-1.5 h-1.5 bg-cta rounded-full opacity-25 animate-pulse"
          style={{ animationDelay: "2s" }}
        />
      </div>
    </div>
  );
};

export default HeroImage;
